/* ============================================
   ASPEN · Global Theme JS
   ============================================ */

(function() {
  'use strict';

  // ===== Mobile Drawer =====
  const drawer = document.querySelector('[data-drawer]');
  const drawerOpenBtn = document.querySelector('[data-menu-open]');
  const drawerCloseBtn = document.querySelector('[data-menu-close]');

  if (drawerOpenBtn && drawer) {
    drawerOpenBtn.addEventListener('click', () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  }

  if (drawerCloseBtn && drawer) {
    drawerCloseBtn.addEventListener('click', () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  }

  // ===== Accordions =====
  document.querySelectorAll('[data-accordion-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('[data-accordion]');
      item.classList.toggle('is-open');
    });
  });

  // ===== Hero: elegir género antes de comprar =====
  const heroCta = document.querySelector('[data-hero-cta]');
  const heroShop = heroCta ? heroCta.querySelector('[data-hero-shop]') : null;
  if (heroCta && heroShop) {
    const reveal = (on) => {
      heroCta.classList.toggle('is-choosing', on);
      heroShop.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) {
        const first = heroCta.querySelector('[data-hero-gender] a');
        if (first) first.focus();
      }
    };
    heroShop.addEventListener('click', (e) => { e.preventDefault(); reveal(true); });
    const back = heroCta.querySelector('[data-hero-gender-back]');
    if (back) back.addEventListener('click', () => { reveal(false); heroShop.focus(); });
  }

  // ===== Cart count refresh from sessionStorage =====
  // (Updated by product.js after add-to-cart)

})();
